import React, { useContext } from 'react';
import { PC_PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/benchmark/components/CommonPageRender/index';
import { PAGE_CONFIG_API } from '../../_config/constant';
import { MOBILE_PAGE_CONFIG } from './mobilePageConfig';
import { LayoutContext } from '../../state/LayoutContext';

const GenrePage = () => {
  const { frameType } = useContext(LayoutContext);

  const pageMap = {
    pcconsole: PC_PAGE_CONFIG,
    mobile: MOBILE_PAGE_CONFIG,
  };

  return (
    <CommonPageRender
      reqParams={'/explore/genre'}
      pageConfigInit={pageMap?.[frameType]}
      api={PAGE_CONFIG_API}
    />
  );
};

export default GenrePage;